import { BracketPeriod, getBracketPeriod, useRootContext } from '../contexts/RootContext'
import { useLocation, Navigate } from 'react-router-dom'
import { useAuthContext } from '../contexts/AuthContext'
import { useToast } from '../contexts/ToastContext'
import { hasInProgressBracketForm } from './bracketFormProgress'
import BracketFormPhaseOne from './BracketFormPhaseOne'
import PageLoading from '../misc/PageLoading'
import React, { useEffect, useMemo, useState } from 'react'

export default function BracketFormContainer() {
  const [createCodeState, setCreateCodeState] = useState(null)
  const [validated, setValidated] = useState(false)
  const { pool, secondChanceAvailabilityLoaded, secondChanceAvailable } = useRootContext()
  const { authorizationHeaders } = useAuthContext()
  const { errorToast } = useToast()
  const location = useLocation()
  const bracketPeriod = getBracketPeriod()
  const requestedCreateCode = useMemo(() => new URLSearchParams(location.search).get('create_code'), [location.search])

  useEffect(() => {
    if (!requestedCreateCode) {
      setCreateCodeState(null)
      setValidated(true)
      return
    }

    setValidated(false)
    fetch(`/api/v2/create_code?create_code=${encodeURIComponent(requestedCreateCode)}`, {
      credentials: 'same-origin',
      headers: authorizationHeaders,
    })
      .then(response => {
        if (response.ok) {
          return response.json()
        } else {
          throw response
        }
      })
      .then(body => {
        setCreateCodeState({
          code: body.code,
          poolId: body.pool_id ?? null,
        })
        setValidated(true)
      })
      .catch(() => {
        setCreateCodeState(null)
        setValidated(true)
        errorToast('Create link is invalid or has already been used.')
      })
  }, [authorizationHeaders, errorToast, requestedCreateCode])

  const createCode = createCodeState?.code ?? null
  const effectivePoolId = createCodeState?.poolId ?? pool?.id ?? null

  if (!validated || !secondChanceAvailabilityLoaded) return <PageLoading />

  if (!(bracketPeriod === BracketPeriod.Open || secondChanceAvailable) && !hasInProgressBracketForm() && !createCode) {
    return <Navigate to="/leaderboard" replace />
  }

  return <BracketFormPhaseOne
    createCode={createCode}
    poolId={effectivePoolId}
    authorizationHeaders={authorizationHeaders}
  />
}
